<template>

      <div class="page page-inner">
        <breadcrumb title="Cash Advance Request"></breadcrumb>
        <div class="card card-fluid">
          <div class="card-header nav-scroller">
            <!-- .nav-tabs -->
            <ul class="nav nav-tabs card-header-tabs">
              <li class="nav-item">
                <a href="#" class="nav-link active" @click.prevent="setActive('cash-advance-request')" data-toggle="tab" >Cash Advance Request</a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" @click.prevent="setActive('cash-advance-approval')" data-toggle="tab" >Subordinate</a>
              </li>
            </ul>
            <!-- /.nav-tabs -->
          </div>
          <!-- .card-body -->
          <div class="card-body">
            <div class="tab-content py-3">
              <div class="tab-pane fade" :class="{ 'active show': isActive('cash-advance-request') }">
                <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div class="dt-buttons btn-group">
                        <button class="btn btn-success btn-modal" v-b-modal.modal-request tabindex="0"  data-title="Request" v-show="action_button.add">
                          <span>Request</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div id="data-table-leave-request-request_filter" class="dataTables_filter">
                        <label>
                          Search:<input type="search" class="form-control" placeholder="" aria-controls="data-table-leave-request-request">
                        </label>
                      </div>
                    </div>
                  </div>

                  <b-table :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy"
                           :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" class="table-height" hover :class="{'hide-scroll': isScrollHide()}">

                    <template v-slot:cell(action)="row">
                      <a class="btn btn-xs "  @click="detailRow(row.item, row.index, $event.target)" title="Detail" v-show="action_button.detail">
                        <em class="fa fa-search"></em>
                      </a>
                      <a class="btn btn-xs "  @click="editRow(row.item, row.index, $event.target)" title="Edit" v-if="row.item.ca_stat_id == 0 && action_button.edit">
                        <em class="fa fa-pencil-alt"></em>
                      </a>
                      <a class="btn btn-xs "  @click="deleteRow(row.item, row.index, $event.target)" title="Delete" v-if="row.item.ca_stat_id == 0 && action_button.delete">
                        <em class="fa fa-trash"></em>
                      </a>
                    </template>
                  </b-table>
                  <div class="row align-items-center">
                    <div class="col-sm-12 col-md-5">
                      <pagination-info :rows="rows" :per-page="perPage" :current-page="currentPage"></pagination-info>
                    </div>
                    <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                      <div class="dataTables_paginate paging_simple_numbers">
                        <b-pagination v-model="currentPage" v-on:click="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" :class="{ 'active show': isActive('cash-advance-approval') }" id="profile">
                <div id="data-table-leave-request-approval_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div id="data-table-leave-approval-request_filter" class="dataTables_filter"><label>Search:<input
                          type="search" class="form-control" placeholder=""
                          aria-controls="data-table-leave-request-request"></label></div>
                    </div>
                  </div>

                  <b-table :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy"
                           :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline " class="table-height" hover :class="{'hide-scroll': isScrollHide()}">

                    <template v-slot:cell(action)="row">
                      <a class="btn btn-xs "  @click="detailRow(row.item, row.index, $event.target)" title="Detail"  >
                        <em class="fa fa-search"></em>
                      </a>
                    </template>
                  </b-table>
                  <div class="row align-items-center">
                    <div class="col-sm-12 col-md-5">
                      <pagination-info :rows="rows" :per-page="perPage" :current-page="currentPage"></pagination-info>
                    </div>
                    <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                      <div class="dataTables_paginate paging_simple_numbers">
                        <b-pagination v-model="currentPage" v-on:click="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.card-body -->
        </div>
        <CashAdvanceInput :project="options_project" ref="mdl" :id="id"></CashAdvanceInput>
        <cash-advance-detail ref="mdl-det" :id="id"></cash-advance-detail>
        <b-modal id="modal-delete" hide-backdrop content-class="shadow" ref="modal-delete" title="Delete" @ok="deleteItem" @hide="resetModal" ok-title="Delete" ok-variant="danger">
          <p class="my-2">
            Are you sure delete this item ?
          </p>
        </b-modal>
      </div>

</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import {BTable, BPagination, VBToggle, VBModal, BModal} from "bootstrap-vue"
import CashAdvanceInput from "@/components/pages/cash-advance/CashAdvanceInput";
import {mapGetters} from "vuex";
import PaginationInfo from "../../PaginationInfo";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import CashAdvanceDetail from "./CashAdvanceDetail";
import Acl from "../../../../libs/AclButton";
export default {
  name: "CashAdvance",
  components:{
    CashAdvanceDetail,
    PaginationInfo,
    CashAdvanceInput,
    BTable,
    Breadcrumb,
    BPagination,
    BModal
  },
  directives:{
    "b-toggle":VBToggle,
    'b-modal':VBModal
  },
  data(){
    return {
      activeItem:"cash-advance-request",
      noCollapse:false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      items:[],
      fields: [
        { key: 'no', sortable: true , thStyle: {maxWidth: '60px', minWidth: '10px'}},
        { key: 'action', sortable: true, thStyle: {maxWidth: '150px', minWidth: '10px'} },
        { key: 'number',label:"Transaction Number", sortable: true },
        { key: 'request_date', sortable: true },
        { key: 'project_abbreviation',label:'Project', sortable: true },
        { key: 'activity_start', sortable: true },
        { key: 'activity_end',label:'End of activity', sortable: true },
        { key: 'cash_advance_purpose', sortable: true },
        { key: 'curr_code',label:"Currency", sortable: true },
        { key: 'cash_advance_amount',label:"Nominal", sortable: true },
        { key: 'ca_stat_name', label:"Status", sortable: true },
      ],
      currentPage:1,
      perPage:20,
      rows:0,
      filter:{
        transaction_number:"",
        period:"all",
        project:"all",
        from_date:"",
        to_date:""
      },
      options_radio: [
        { text: 'All', value: 'all' },
        { text: 'Range', value: 'range' },
      ],
      options_project:[
        {name:"All", id:"all"}
      ],
      config_date:{
        //wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        minDate:'today',
        locale: {
          rangeSeparator: ' - '
        },
      },
      id:null,
      showDate:false,
      title:"More",
      action_button:{
        add:false,
        edit:false,
        delete:false,
        detail:false
      }
    }
  },
  computed:{
    ...mapGetters([ 'scrollbarHide']),
  },
  watch:{
    currentPage:function (){
      this.getData()
    }
  },
  methods:{
    isScrollHide(){
      return this.scrollbarHide
    },
    setActive(itemTabs){
      this.activeItem = itemTabs
      this.getData()
    },
    isActive(itemTabs){
      return this.activeItem === itemTabs
    },
    getData(){
      this.items = []
      let userProfile = this.$store.getters.userProfile
      let payload = {
        emp_id: this.$store.getters.empId,
        lang:"en",
        company_id:userProfile.data.attributes.company_id,
        page:this.currentPage,
        limit:this.perPage
      }

      if (this.activeItem === "cash-advance-approval") payload.approval = true
      AxiosCall.Get(payload, urlApi.cash_advance.get).then(res=>{
        if (res.success){
          let no = (this.currentPage - 1) * this.perPage + 1
          for (let data of res.atributes){
            data.no = no++
            this.items.push(data)
          }
          this.rows = res.total
        }else{
          this.errorMessage(res.message)
        }
      })
    },
    toInput(){
      this.$router.push({path:"cash-advance-input"})
    },
    isShowDate(){
      this.showDate = true
      if (this.filter.period !== "all"){
        this.showDate =false
      }
    },
    isTitle(){
     this.title = (this.title === "More") ? "Less" :"More"
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    getProject(){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.project.projectAll).then(resp=>{
        if (resp.success){
          this.options_project.push.apply(this.options_project,resp.atributes)
        }else{
          this.errorMessage(res.message)
        }
      })
    },
    editRow(item){
      this.id = item.id
      this.$refs.mdl.$refs.modal.show()
    },
    resetModal(){
      this.id = null
      this.$refs["modal-delete"].hide()
    },
    deleteRow(item){
      this.id = item.id
      this.$refs["modal-delete"].show()
    },
    deleteItem(){
      AxiosCall.Delete( urlApi.cash_advance.delete+"/"+this.id).then(res=>{
        if (res.success){
          this.getData()
          this.successMessage(res.message)
        }else{
          this.errorMessage(res.message)
        }
        this.resetModal()
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    detailRow(item){
      this.id = item.id
      this.$refs["mdl-det"].$refs["modal-det"].show()
    },
    checkAction(){
      for(let act in this.action_button){
        this.action_button[act] = Acl(this.$options.name, act)
      }
    }
  },
  mounted() {
    this.checkAction()
    this.getProject()
    this.getData()
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
     this.title = (isJustShown) ? "Less" :"More"
    })

  }
}
</script>